var map = {
	"./IBM.gif": 195,
	"./amiga.gif": 196,
	"./atari.gif": 197,
	"./linux.gif": 198,
	"./mac.gif": 199,
	"./mac_new.gif": 200,
	"./next.gif": 201,
	"./obscure.gif": 202,
	"./unix.gif": 203,
	"./windows.gif": 204,
	"./windows11.gif": 205,
	"./windows_new.png": 206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;